const SelfJoinLinkForm = () => (
    <div>
      <h3 className="primary-text">Self-Join Links</h3>
      <div className="mt-2 bg-white border rounded px-2 py-3">
        <div className="d-flex  text-black" style={{ fontSize: "16px",fontWeight: "600" }}>
            
            <p className="col-md-6">
              Class Name
            </p>
            <p className="col-md-6">Links</p>
        </div>
        <div className="d-flex  text-black" style={{ fontSize: "16px",fontWeight: "600" }}>
            
            <p className="col-md-6">
              Computer Class
            </p>
            <a href="#" className="col-md-6">
              <span className="primary-text">https://edx.org/self-join/123456789</span>     
            </a>
        </div>
        <div className="d-flex  text-black" style={{ fontSize: "16px",fontWeight: "600" }}>
            
            <p className="col-md-6">
              Computer Class
            </p>
            <a href="#" className="col-md-6">
              <span className="primary-text">https://edx.org/self-join/123456789</span>     
            </a>
        </div>
        <div className="d-flex  text-black" style={{ fontSize: "16px",fontWeight: "600" }}>
            
            <p className="col-md-6">
              Computer Class
            </p>
            <a href="#" className="col-md-6">
              <span className="primary-text">https://edx.org/self-join/123456789</span>     
            </a>
        </div>
        <div className="d-flex  text-black" style={{ fontSize: "16px",fontWeight: "600" }}>
            
            <p className="col-md-6">
              Computer Class
            </p>
            <a href="#" className="col-md-6">
              <span className="primary-text">https://edx.org/self-join/123456789</span>     
            </a>
        </div>

      </div>
    
    </div>
  );
  
  export default SelfJoinLinkForm;
  